var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Checkbox } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { ThemeProvider } from '@material-ui/styles';
import classNames from 'classnames';
import { compare } from 'fast-json-patch';
import produce from 'immer';
import { debounce, groupBy, uniqueId } from 'lodash';
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { createMedication, deletePatientMedication, finaliseMedications, getMedicationsSummaryByAuth, getMedicationsToReprescribeByAuth, getMedicationsToRequestByPatientAuthKeys, getMedicationsToStopByAuth, getPatientMedicationToFinalise, patchMedication, represcribeMedications, stopMedications } from '../Async/MedicationsSummaryAsync';
import { useUserInformation } from '../Authentication/ApplicationAuthentication';
import { Button, ButtonMode } from '../Components/Button';
import { DetailsPane, DetailsPaneState } from '../Components/DetailsPane';
import { ErrorBoundary, useError } from '../Components/ErrorBoundary';
import { ModalAnimationStyle } from '../Components/FullScreenModal';
import { CloseIcon } from '../Components/Icons';
import { LayoutCentral } from '../Components/LayoutCentral';
import { MedicationCard, MedicationCardMode } from '../Components/MedicationCard';
import { MedicationTextHighlighter } from '../Components/MedicationTextHighlighter';
import { LoadingPlaceholder } from '../Components/Placeholder';
import { TwoPanelLayout } from '../Components/TwoPanelLayout';
import { displayError, displayMessage } from '../Config/ApplicationConfig';
import { useMedicationSettings } from '../Config/MedicationConfig';
import { MedicationCourse, MedicationStatus, MedicationType, PoisonScheduleStatus, VerbalOrderStatus } from '../Contracts/MedicationModels';
import { MedSummarySortColumn, MedSummarySortOrder } from '../Contracts/MedicationsSummarySearchFilter.Request';
import { FinaliseMedicationForm } from '../FinaliseMedication/FinaliseMedicationForm';
import { useAsync, UseAsyncStatus } from '../Hooks/useAsync';
import { MedicationsBrowserDialog } from '../MedicationBrowser/MedicationsBrowserDialog';
import { MedicationOverviewLoader } from '../MedicationOverview/MedicationOverview';
import { convertTimelineFilterToQueryObject, useMedicationTimelines } from '../MedicationTimeline/useMedicationTimelines';
import { AddPharmacyRequestForm } from '../PharmacyRequests/AddPharmacyRequestForm/AddPharmacyRequestForm';
import { getOnCreatePharmacyRequest } from '../PharmacyRequests/PharmacyRequests';
import { ControlledDialogActions, ControlledMedicationDialog, useControlledMedicationDialog } from '../ReprescribeMedication/ControlledMedicationDialog';
import { isFreeTextMedication, ReprescribeFreeTextMedication } from '../ReprescribeMedication/ReprescribeFreeTextMedication';
import { getExpiresOn, ReprescribeMedication } from '../ReprescribeMedication/ReprescribeMedication';
import { ReprescribeSingleMedicationDialog } from '../ReprescribeMedication/ReprescribeSingleMedicationDialog';
import { routeForDetails, routeForDetailsMatch, routeForSummary } from '../Routes';
import { defaultAuthoringSystem, emptyGuid, selfAuthoringSystemForeignKey } from '../Shared/Constants';
import { duration, ValidDateFormats } from '../Shared/DateUtilities';
import { getFirstErrorMessageFromApiError, isDomainValidationError } from '../Shared/DomainValidationFunctions';
import { useHttpConfig } from '../Shared/HttpRequestExecutor';
import { ApplicationStorageKeys, deleteFromLocalStorage, loadFromLocalStorage, saveToLocalStorage } from '../Shared/LocalStorage';
import { expiryStatusFromDate } from '../Shared/MedicationsHelpers';
import { MedicationExpiryType } from '../Shared/Types';
import { useDecisionSupportStatusUpdatedSignalR } from '../SignalR/DecisionSupportSignalR';
import { usePatientMedicationUpdatedSignalR } from '../SignalR/PatientMedicationSignalR';
import { StopMedication } from '../StopMedication/StopMedication';
import { iconLight } from '../Styles/Colours';
import { muiMedicationsTheme } from '../Styles/Theme';
import { ReassignVerbalOrderDialog } from '../VerbalOrder/ReassignVerbalOrderDialog';
import { ReviewVerbalOrderDialog } from '../VerbalOrder/ReviewVerbalOrderDialog';
import { AddMedicationMenu } from './AddMedicationMenu';
import { DeleteMedicationDialog } from './DeleteMedicationDialog';
import { CourseScriptNumber } from './MedicationCourseScriptNumber';
import { MedicationPlaceholder } from './MedicationPlaceholder';
import styles from './MedicationsSummary.module.css';
import { convertFilterToQueryObject, MedicationsSummaryFilter, useMedicationsSummaryFilter } from './MedicationsSummaryFilter';
import { MedicationsSummaryList } from './MedicationsSummaryList';
import { MedicationStatusIcon } from './MedicationStatusIcon';
import { AllowedActionButtons, MedicationSummaryDataTable, StyledTableCell } from './MedicationSummaryDataTable';
import { expiryDate, getDurationType, performedDate } from './MedicationSummaryDuration';
import { MedicationSummaryExpiryCard } from './MedicationSummaryExpiryCard';
import { NavigationPrompt } from './NavigationPrompt';
import { MedicationSummaryHeader } from './SummaryHeader/MedicationSummaryHeader';
import { calculateCourseInstructions, isMedicationsSummary } from './Utilities';
import { EditMedicationLoader } from '../EditMedicationModal/EditMedicationLoader';
import { ClinicalDecisionSupportDialog } from '../ClinicalDecisionSupport/ClinicalDecisionSupportDialog';
var getColumns = function (config) {
    return [
        {
            name: 'course',
            title: 'course',
            getCellValue: function (row) { return row.lastMedication.course; }
        },
        {
            name: 'product',
            title: 'Product & status',
            getCellValue: function (row) {
                var isSelected = row.lastMedication.id === config.selectedMedicationId;
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.productColumn },
                        React.createElement(MedicationStatusIcon, { medicationStatus: row.lastMedication.status }),
                        React.createElement(MedicationCard, { name: row.productPack.name, strength: row.productPack.strength, strengthUnit: row.productPack.strengthUnit, type: row.lastMedication.type, selected: isSelected, size: row.productPack.size, productPackAmount: row.lastMedication.productPackAmount, repeatsAmount: row.lastMedication.repeatsAmount, mode: MedicationCardMode.Standard, isNonStandardPackSize: row.lastMedication.isNonStandardPackSize, nonStandardPackSize: row.lastMedication.nonStandardPackSize })),
                    row.productPack.productRemoved && (React.createElement("span", { className: styles.notAvailableLebel }, "No longer available"))));
            }
        },
        {
            name: 'courseInstructions',
            title: 'Order instructions',
            getCellValue: function (row) {
                var isSelected = row.lastMedication.id === config.selectedMedicationId;
                var expiryStatus = expiryStatusFromDate(row.lastMedication.expiresOn);
                var instructions = calculateCourseInstructions({
                    orderInstructions: row.lastMedication.orderTextInstructions,
                    dosageInstructions: row.lastMedication.dosageTextInstructions,
                    type: row.lastMedication.type
                });
                return (React.createElement(Tooltip, { id: 'instructions', title: instructions },
                    React.createElement(MedicationTextHighlighter, { selected: isSelected, status: row.lastMedication.status, expiryStatus: expiryStatus, width: 268 },
                        React.createElement("div", { className: classNames(styles.rowMainText, styles.wrappingCell) }, instructions))));
            }
        },
        {
            name: 'courseScriptNumber',
            title: 'Script no.',
            getCellValue: function (row) {
                var _a;
                var isSelected = row.lastMedication.id === config.selectedMedicationId;
                var expiryStatus = expiryStatusFromDate(row.lastMedication.expiresOn);
                var newVerbalOrder = ((_a = row.lastMedication.verbalOrderDetail) === null || _a === void 0 ? void 0 : _a.status) === VerbalOrderStatus.New;
                return (React.createElement(CourseScriptNumber, { selected: isSelected, status: row.lastMedication.status, expiryStatus: expiryStatus, scriptNumber: row.lastMedication.scriptNumber, medicationType: row.lastMedication.type, outputStatus: row.lastMedication.scriptOutputStatus, scriptOutputDescription: row.lastMedication.scriptOutputDescription, newVerbalOrder: newVerbalOrder, verbalOrderTerm: config.verbalOrderTerm }));
            }
        },
        {
            name: 'courseAddedOn',
            title: 'Start date',
            getCellValue: function (row) {
                var isSelected = row.lastMedication.id === config.selectedMedicationId;
                var expiryStatus = expiryStatusFromDate(row.lastMedication.expiresOn);
                return (React.createElement(MedicationTextHighlighter, { selected: isSelected, status: row.lastMedication.status, expiryStatus: expiryStatus, width: 98 }, moment(row.lastMedication.performedOn).format(ValidDateFormats.DisplayWithHyphen)));
            }
        },
        {
            name: 'courseExpires',
            title: 'End date',
            getCellValue: function (row) {
                var _a;
                var chartDuration = row.lastMedication.expiryType === MedicationExpiryType.Chart;
                var isSelected = row.lastMedication.id === config.selectedMedicationId;
                var expiryStatus = expiryStatusFromDate(row.lastMedication.expiresOn);
                var expiresOn = (_a = row.lastMedication.expiresOn) !== null && _a !== void 0 ? _a : '';
                return (React.createElement("div", { style: { width: 98 } },
                    React.createElement(MedicationSummaryExpiryCard, { selected: isSelected, medicationExpiresOn: expiresOn, medicationExpiry: expiryStatus, medicationStatus: row.lastMedication.status, isChartDuration: chartDuration })));
            }
        },
        {
            name: 'courseDuration',
            title: 'Duration',
            getCellValue: function (row) {
                var chartDuration = row.lastMedication.expiryType === MedicationExpiryType.Chart;
                if (chartDuration)
                    return React.createElement("span", null, "(Chart duration)");
                var courseDuration = row.lastMedication.expiresOn === null
                    ? ''
                    : duration(moment(row.lastMedication.expiresOn, ValidDateFormats.IsoFormat), moment(row.lastMedication.performedOn, ValidDateFormats.IsoFormat));
                var isSelected = row.lastMedication.id === config.selectedMedicationId;
                var expiryStatus = expiryStatusFromDate(row.lastMedication.expiresOn);
                return (React.createElement(Tooltip, { id: 'course-duration', title: courseDuration },
                    React.createElement(MedicationTextHighlighter, { selected: isSelected, status: row.lastMedication.status, expiryStatus: expiryStatus, width: 110 }, courseDuration)));
            }
        },
        {
            name: 'startedOn',
            title: 'First prescribed',
            getCellValue: function (row) {
                var isSelected = row.lastMedication.id === config.selectedMedicationId;
                var expiryStatus = expiryStatusFromDate(row.lastMedication.expiresOn);
                return (React.createElement(MedicationTextHighlighter, { selected: isSelected, status: row.lastMedication.status, expiryStatus: expiryStatus, width: 98 }, row.lastMedication.firstPrescribedOn ? moment(row.lastMedication.firstPrescribedOn).format(ValidDateFormats.DisplaySlashSpace) : ""));
            }
        },
        {
            name: 'totalDuration',
            title: 'Total duration',
            getCellValue: function (row) {
                var totalDuration = row.lastMedication.expiresOn === null
                    ? ''
                    : duration(moment(row.lastMedication.expiresOn, ValidDateFormats.IsoFormat), moment(row.lastMedication.performedOn, ValidDateFormats.IsoFormat));
                var isSelected = row.lastMedication.id === config.selectedMedicationId;
                var expiryStatus = expiryStatusFromDate(row.lastMedication.expiresOn);
                return (React.createElement(Tooltip, { id: 'course-duration', title: totalDuration },
                    React.createElement(MedicationTextHighlighter, { selected: isSelected, status: row.lastMedication.status, expiryStatus: expiryStatus, width: 110 }, totalDuration)));
            }
        },
        {
            name: 'allowedActions',
            title: 'Actions',
            getCellValue: function allowedActionsRenderer(row) {
                return (React.createElement("div", { className: styles.allowedActionsButtons },
                    React.createElement(AllowedActionButtons, { allowedActions: row.allowedActions, editMedication: function () { return config.editMedication(row.lastMedication.id); }, adjustMedication: function () { return config.adjustMedication(row.lastMedication.id); }, stopMedication: function () { return config.stopMedication(row.lastMedication.id); }, deleteMedication: function () {
                            return config.deleteMedication(row.productPack.name, row.lastMedication.id);
                        }, represcribeMedication: function () {
                            return config.represcribeMedication(row.productPack.name, row.lastMedication, row.productPack, row.isFreeTextMedication);
                        }, reassignVerbalOrder: function () {
                            config.reassignVerbalOrder(row.lastMedication);
                        }, reviewVerbalOrder: function () {
                            config.reviewVerbalOrder(row.lastMedication);
                        }, verbalOrderTerm: config.verbalOrderTerm })));
            }
        }
    ];
};
var EmptyPoisonSchedule = {
    name: 'not-poison-schedule',
    code: 'nps',
    codingSystemUri: '',
    codingSystemValue: '',
    codingSystemVersion: '',
    orderNumber: 0,
    poisonScheduleStatus: PoisonScheduleStatus.None
};
export var MedicationsSummary = function (props) {
    var userInfo = useUserInformation();
    var contents = userInfo.user.status === 'loaded' ? (React.createElement(Summary, __assign({}, props, { userId: userInfo.user.userId }))) : (React.createElement(LoadingPlaceholder, null));
    return (React.createElement(ErrorBoundary, null,
        React.createElement(ThemeProvider, { theme: muiMedicationsTheme }, contents)));
};
export var Dialog;
(function (Dialog) {
    Dialog[Dialog["None"] = 0] = "None";
    Dialog[Dialog["Stop"] = 1] = "Stop";
    Dialog[Dialog["Finalise"] = 2] = "Finalise";
})(Dialog || (Dialog = {}));
// Sort orders
var coursesSortOrder = [
    MedicationCourse.None,
    MedicationCourse.Regular,
    MedicationCourse.ShortCourse,
    MedicationCourse.AsRequired,
    MedicationCourse.Daa
];
// Enum to facilitate ease of use
var PharmacyRequestWizardView;
(function (PharmacyRequestWizardView) {
    PharmacyRequestWizardView["None"] = "none";
    PharmacyRequestWizardView["AsWizardStep"] = "asWizardStep";
    PharmacyRequestWizardView["AsStandAloneWizard"] = "asStandAloneWizard";
})(PharmacyRequestWizardView || (PharmacyRequestWizardView = {}));
var Summary = function (props) {
    var _a, _b, _c, _d, _e;
    var httpConfig = useHttpConfig();
    var throwError = useError();
    var rootMatch = useRouteMatch();
    var detailsMatch = useRouteMatch(routeForDetailsMatch(rootMatch.path));
    var selectedMedicationIdFromRoute = (detailsMatch === null ? { medicationId: undefined } : detailsMatch.params).medicationId;
    var medicationSettings = useMedicationSettings();
    var decisionSupportSettings = medicationSettings.settings.decisionSupportSettings;
    var _f = __read(useState(false), 2), showClinicalDecisionSupportDialog = _f[0], setShowClinicalDecisionSupportDialog = _f[1];
    var _g = __read(useState(loadFromLocalStorage(ApplicationStorageKeys.MedicationsSummaryS8MultiReprescribe, {
        isMultiReprescribe: false
    }).isMultiReprescribe), 2), isMultiReprescribe = _g[0], setIsMultiReprescribe = _g[1];
    var isCdsEnabled = (decisionSupportSettings.medicationToConditionEnabled ||
        decisionSupportSettings.medicationToAllergiesEnabled ||
        decisionSupportSettings.medicationToMedicationEnabled ||
        decisionSupportSettings.medicationToPregnancyEnabled);
    // Patch view is just to facilitate access to the old patch system for testing
    var _h = __read(useState(''), 2), showPatientMedicationPatchView = _h[0], setShowPatientMedicationPatchView = _h[1];
    var history = useHistory();
    var location = useLocation();
    var _j = __read(useState(uniqueId('local-event-id-')), 2), localEventId = _j[0], setLocalEventId = _j[1];
    var updateLocalEventId = function () {
        setLocalEventId(uniqueId('local-event-id-'));
    };
    var eventId = (_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.eventId) !== null && _b !== void 0 ? _b : 'init';
    var updateMedicationLoaded = function () {
        if (selectedMedicationIdFromRoute) {
            history.replace(routeForDetails(rootMatch.url, selectedMedicationIdFromRoute), {
                eventId: moment().format(ValidDateFormats.DateTimeIso)
            });
        }
    };
    var _k = __read(useState(false), 2), showReprescribeSingleMedicationDialog = _k[0], setShowReprescribeSingleMedicationDialog = _k[1];
    var _l = __read(useState(false), 2), showReprescribeMedication = _l[0], setShowReprescribeMedication = _l[1];
    var _m = __read(useState(false), 2), showDeleteMedication = _m[0], setShowDeleteMedication = _m[1];
    var _o = __read(useState(false), 2), showReviewVerbalOrder = _o[0], setShowReviewVerbalOrder = _o[1];
    var _p = __read(useState(false), 2), ignoreSelectedIdFromRoute = _p[0], setIgnoreSelectedIdFromRoute = _p[1];
    var _q = __read(useState(''), 2), selectedMedicationNameFromList = _q[0], setSelectedMedicationNameFromList = _q[1];
    var _r = __read(useState(), 2), selectedLastMedicationFromList = _r[0], setSelectedLastMedicationFromList = _r[1];
    var _s = __read(useState(''), 2), selectedMedicationIdFromList = _s[0], setSelectedMedicationIdFromList = _s[1];
    var _t = __read(useState(null), 2), showMedicationsBrowserDialog = _t[0], setShowMedicationsBrowserDialog = _t[1];
    var _u = __read(useState(true), 2), subFormSaved = _u[0], setSubFormSaved = _u[1];
    var _v = __read(useState(null), 2), discardAction = _v[0], setDiscardAction = _v[1];
    var _w = __read(useState(false), 2), filterOpen = _w[0], setFilterOpen = _w[1];
    var _x = __read(useState(false), 2), showReassignVerbalOrder = _x[0], setShowReassignVerbalOrder = _x[1];
    var _y = __read(useState(''), 2), medicationBrowserNameFilter = _y[0], setMedicationBrowserNameFilter = _y[1];
    var _z = __read(useState(null), 2), shortenedMedToReprescribe = _z[0], setShortenedMedToReprescribe = _z[1];
    var showStopMedication = ((_c = location.state) === null || _c === void 0 ? void 0 : _c.dialog) === Dialog.Stop;
    var showFinaliseMedicationWizard = ((_d = location.state) === null || _d === void 0 ? void 0 : _d.dialog) === Dialog.Finalise;
    var _0 = __read(useState(PharmacyRequestWizardView.None), 2), showPharmacyRequestWizard = _0[0], setShowPharmacyRequestWizard = _0[1];
    var controlledMedicationHandler = useControlledMedicationDialog({
        rootUrl: rootMatch.url,
        saveAppUrlForReload: props.setUrlForControlledMedicationReload,
        handleAddMedication: function (action) { return __awaiter(void 0, void 0, void 0, function () {
            var result, err_1, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, createMedication(action.payload)];
                    case 1:
                        result = _a.sent();
                        navigateToMedication(result.id);
                        handleMedicationUpdated();
                        displayMessage('Medication added');
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        errorMessage = 'Unable to save Medication';
                        if (isDomainValidationError(err_1)) {
                            errorMessage = getFirstErrorMessageFromApiError(err_1);
                            displayError(errorMessage);
                        }
                        else {
                            // TODO: Should we blow up the app if this fails?
                            throwError(err_1);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        handleReprescribe: function (action) { return __awaiter(void 0, void 0, void 0, function () {
            var results, err_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, represcribeMedications(action.patient.authoringSystem, action.patient.authoringSystemForeignKey, action.payload)];
                    case 1:
                        results = _c.sent();
                        displayMessage("Medication" + (((_a = results.medications) === null || _a === void 0 ? void 0 : _a.length) > 1 ? 's' : '') + " saved as draft.");
                        if (((_b = results.medications) === null || _b === void 0 ? void 0 : _b.length) === 1)
                            navigateToMedication(results.medications[0], true);
                        handleMedicationUpdated();
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _c.sent();
                        // TODO: Should we blow up the app if this fails?
                        throwError(err_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        handleEditMedication: function (action) { return __awaiter(void 0, void 0, void 0, function () {
            var operations, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        operations = compare({}, __assign(__assign({}, action.payload), { medication: !!action.payload.medication && !!action.payload.medication.originalMedication
                                ? {
                                    code: action.payload.medication.originalMedication.code,
                                    name: action.payload.medication.originalMedication.name
                                }
                                : null }));
                        return [4 /*yield*/, patchMedication(action.patientMedicationId, operations)];
                    case 1:
                        _a.sent();
                        displayMessage('Medication updated');
                        navigateToMedication(action.patientMedicationId);
                        handleMedicationUpdated();
                        return [3 /*break*/, 3];
                    case 2:
                        err_3 = _a.sent();
                        // TODO: Should we blow up the app if this fails?
                        throwError(err_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }
    });
    var triggerDiscardAction = function () {
        if (discardAction)
            discardAction();
        updateLocalEventId();
        updateMedicationLoaded();
        setDiscardAction(null);
    };
    var confirmFormIsValidAndTakeAction = function (action) {
        if (subFormSaved)
            action();
        else
            setDiscardAction(function () { return action; });
    };
    var medicationTimeLineState = useMedicationTimelines({
        patient: {
            authKey: props.patient.authoringSystemForeignKey,
            authSystem: props.patient.authoringSystem
        }
    });
    var _1 = __read(useState(null), 2), addNewMenuTarget = _1[0], setAddNewMenuTarget = _1[1];
    var medicationsSummaryAsync = useAsync({
        httpConfig: httpConfig,
        getApi: getMedicationsSummaryByAuth
    });
    var draftMedications = ((_e = medicationsSummaryAsync.data) !== null && _e !== void 0 ? _e : []).filter(function (it) { return it.lastMedication.status === MedicationStatus.Draft; });
    var draftMedicationIds = draftMedications.map(function (it) { return it.lastMedication.id; }).join('|');
    useEffect(function () {
        if (props.onDraftMedicationsChanged) {
            props.onDraftMedicationsChanged(draftMedications
                ? draftMedications.map(function (it) { return ({
                    id: it.lastMedication.id,
                    authoringSystem: it.lastMedication.authoringSystem,
                    authoringSystemForeignKey: it.lastMedication.authoringSystemForeignKey,
                    productPackName: it.productPack.name
                }); })
                : []);
        }
        setShowClinicalDecisionSupportDialog(draftMedicationIds.length > 0 && isMultiReprescribe && isCdsEnabled && selectedMedicationIdFromRoute == null);
    }, [draftMedicationIds]);
    useDecisionSupportStatusUpdatedSignalR({
        patient: props.patient,
        onSignalResponse: function (decisionSupportStatusUpdated) {
            // TODO 67316 Review this (do I need to make changes?)
            medicationsSummaryAsync.updateData(function (currentSummary) {
                if (currentSummary) {
                    var updatedSummary = produce(currentSummary, function (draft) {
                        var itemIndex = draft.findIndex(function (it) {
                            return it.lastMedication.authoringSystem ===
                                decisionSupportStatusUpdated.patientMedication.authoringSystem &&
                                it.lastMedication.authoringSystemForeignKey ===
                                    decisionSupportStatusUpdated.patientMedication.authoringSystemForeignKey;
                        });
                        if (itemIndex >= 0) {
                            var summaryItem = draft[itemIndex];
                            summaryItem.lastMedication = __assign(__assign({}, summaryItem.lastMedication), { decisionSupportStatus: decisionSupportStatusUpdated.decisionSupportDetail.status });
                        }
                    });
                    return updatedSummary;
                }
                return currentSummary;
            });
        }
    });
    usePatientMedicationUpdatedSignalR({
        patient: props.patient,
        onSignalResponse: function (medicationUpdated) {
            medicationsSummaryAsync.updateData(function (currentSummary) {
                if (currentSummary) {
                    var updatedSummary = produce(currentSummary, function (draft) {
                        var itemIndex = draft.findIndex(function (it) {
                            return it.lastMedication.authoringSystem === medicationUpdated.authoringSystem &&
                                it.lastMedication.authoringSystemForeignKey ===
                                    medicationUpdated.authoringSystemForeignKey;
                        });
                        if (itemIndex >= 0) {
                            var clientQueueName = medicationUpdated.clientQueueName, id = medicationUpdated.id, authoringSystem = medicationUpdated.authoringSystem, authoringSystemForeignKey = medicationUpdated.authoringSystemForeignKey, allowedActions = medicationUpdated.allowedActions, medicationType = medicationUpdated.medicationType, scriptOutput = medicationUpdated.scriptOutput, medicationValues = __rest(medicationUpdated, ["clientQueueName", "id", "authoringSystem", "authoringSystemForeignKey", "allowedActions", "medicationType", "scriptOutput"]);
                            var summaryItem = draft[itemIndex];
                            summaryItem.allowedActions = medicationUpdated.allowedActions;
                            summaryItem.lastMedication = __assign(__assign(__assign({}, summaryItem.lastMedication), medicationValues), { type: medicationType, scriptOutputStatus: scriptOutput.status });
                        }
                    });
                    return updatedSummary;
                }
                return currentSummary;
            });
        }
    });
    var showMedicationsBrowser = function (medicationType) {
        setShowMedicationsBrowserDialog(medicationType);
    };
    var closeMedicationsBrowser = function () {
        setAddNewMenuTarget(null);
        setShowMedicationsBrowserDialog(null);
        setMedicationBrowserNameFilter('');
        setShortenedMedToReprescribe(null);
    };
    var navigateToMedication = function (patientMedicationId, fromReprescribe) {
        // We are using the state to trigger a change event.
        history.push(routeForDetails(rootMatch.url, patientMedicationId), {
            eventId: moment().format(ValidDateFormats.DateTimeIso),
            fromReprescribe: !!fromReprescribe
        });
    };
    var showDialog = function (dialog) {
        if (dialog !== Dialog.None) {
            setDiscardAction(null);
        }
        var url = selectedMedicationIdFromRoute
            ? routeForDetails(rootMatch.url, selectedMedicationIdFromRoute)
            : routeForSummary(rootMatch.url);
        history.replace(url, __assign(__assign({}, location.state), { eventId: dialog === Dialog.None || subFormSaved ? eventId : moment().format(ValidDateFormats.DateTimeIso), dialog: dialog }));
    };
    var createNewMedication = function (newMedication, poisonScheduleStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var result, err_4, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!controlledMedicationHandler.requiresAuthentication(poisonScheduleStatus)) return [3 /*break*/, 1];
                    controlledMedicationHandler.showControlledMedicationDialog({
                        action: {
                            type: ControlledDialogActions.AddMedication,
                            payload: newMedication,
                            patient: props.patient
                        },
                        handleCancel: function () {
                            // No operation needed.
                        }
                    });
                    return [3 /*break*/, 4];
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createMedication(newMedication)];
                case 2:
                    result = _a.sent();
                    // Must be executed prior to calling props, if the parent unmounts this component it will cause state async issues
                    handleMedicationUpdated();
                    closeMedicationsBrowser();
                    navigateToMedication(result.id);
                    return [3 /*break*/, 4];
                case 3:
                    err_4 = _a.sent();
                    errorMessage = 'Unable to save Medication';
                    if (isDomainValidationError(err_4)) {
                        errorMessage = getFirstErrorMessageFromApiError(err_4);
                        displayError(errorMessage);
                    }
                    else {
                        throwError(err_4);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var selectMedicationFromBrowser = function (originalMedication) { return __awaiter(void 0, void 0, void 0, function () {
        var medicationExpiryType, maxPharmacyRequestExpiry, request, err_5;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (showMedicationsBrowserDialog === null)
                        return [2 /*return*/];
                    medicationExpiryType = (showMedicationsBrowserDialog === MedicationType.EnrmcScript ||
                        showMedicationsBrowserDialog === MedicationType.ComplementaryTherapyOrder) && ((_a = originalMedication.poisonSchedule) === null || _a === void 0 ? void 0 : _a.code) !== 'S8'
                        ? MedicationExpiryType.Chart
                        : MedicationExpiryType.Fixed;
                    maxPharmacyRequestExpiry = ((_b = originalMedication.poisonSchedule) === null || _b === void 0 ? void 0 : _b.code) !== 'S8' ? medicationSettings.getDefaultDurationAsMoment() : medicationSettings.getS8DurationAsMoment();
                    request = {
                        authoringSystem: defaultAuthoringSystem,
                        authoringSystemForeignKey: selfAuthoringSystemForeignKey,
                        patient: {
                            id: emptyGuid,
                            // We don't have the Medications service patientId, only its auth key.
                            authoringSystem: props.patient.authoringSystem,
                            authoringSystemForeignKey: props.patient.authoringSystemForeignKey
                        },
                        medication: {
                            code: originalMedication.code,
                            name: originalMedication.name,
                            codingSystemUri: originalMedication.codingSystemUri,
                            codingSystemValue: originalMedication.codingSystemValue,
                            codingSystemVersion: originalMedication.codingSystemVersion
                        },
                        service: {
                            id: emptyGuid,
                            authoringSystem: props.service.authoringSystem,
                            authoringSystemForeignKey: props.service.authoringSystemForeignKey
                        },
                        isFreeTextMedication: false,
                        supplyAllRepeatsAtOnce: false,
                        performedOn: moment().format(ValidDateFormats.IsoFormat),
                        generatedOn: moment().format(ValidDateFormats.NodeDateTimeTimezone),
                        problems: [],
                        viewingRight: props.getDefaultViewingRight(),
                        expiresOn: medicationExpiryType === MedicationExpiryType.Chart && maxPharmacyRequestExpiry !== null
                            ? maxPharmacyRequestExpiry.format(ValidDateFormats.IsoFormat)
                            : null,
                        notes: '',
                        medicationType: showMedicationsBrowserDialog,
                        medicationExpiry: medicationExpiryType,
                        pharmacyRequestId: null,
                        jurisdictionalControlledSubstanceReference: null,
                        pbsDetail: (originalMedication === null || originalMedication === void 0 ? void 0 : originalMedication.pbsDetail) ? originalMedication === null || originalMedication === void 0 ? void 0 : originalMedication.pbsDetail : undefined
                    };
                    if (!(shortenedMedToReprescribe !== null && ((_c = shortenedMedToReprescribe.medications[0].shortenedMedsDetails) === null || _c === void 0 ? void 0 : _c.productRemoved))) return [3 /*break*/, 5];
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    shortenedMedToReprescribe.medications[0].shortenedMedsDetails.alternateMedication = request;
                    return [4 /*yield*/, handleShortenedMedToReprescribe(shortenedMedToReprescribe, (_d = originalMedication.poisonSchedule) === null || _d === void 0 ? void 0 : _d.poisonScheduleStatus)];
                case 2:
                    _f.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_5 = _f.sent();
                    displayError('Unable to re-prescribe medication');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
                case 5: return [4 /*yield*/, createNewMedication(request, (_e = originalMedication.poisonSchedule) === null || _e === void 0 ? void 0 : _e.poisonScheduleStatus)];
                case 6:
                    _f.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleShortenedMedToReprescribe = function (shortenedMedToReprescribe, poisonScheduleStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!controlledMedicationHandler.requiresAuthentication(poisonScheduleStatus)) return [3 /*break*/, 1];
                    controlledMedicationHandler.showControlledMedicationDialog({
                        action: {
                            type: ControlledDialogActions.Represcribe,
                            payload: shortenedMedToReprescribe,
                            patient: props.patient
                        },
                        handleCancel: function () {
                            // Should take no further action.
                        }
                    });
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, represcribeMedications(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, shortenedMedToReprescribe)];
                case 2:
                    result = _a.sent();
                    closeMedicationsBrowser();
                    displayMessage('Medication saved as draft');
                    onReprescribe(result === null || result === void 0 ? void 0 : result.medications[0]);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var selectFreeTextMedicationFromBrowser = function (name, medicationType) { return __awaiter(void 0, void 0, void 0, function () {
        var medicationExpiryType, maxPharmacyRequestExpiry, request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (medicationType === null)
                        return [2 /*return*/];
                    medicationExpiryType = medicationType === MedicationType.EnrmcScript || medicationType === MedicationType.ComplementaryTherapyOrder
                        ? MedicationExpiryType.Chart
                        : MedicationExpiryType.Fixed;
                    maxPharmacyRequestExpiry = medicationSettings.getDefaultDurationAsMoment();
                    request = {
                        authoringSystem: defaultAuthoringSystem,
                        authoringSystemForeignKey: selfAuthoringSystemForeignKey,
                        patient: {
                            id: emptyGuid,
                            // We dont have the Medications service patientId, only its auth key.
                            authoringSystem: props.patient.authoringSystem,
                            authoringSystemForeignKey: props.patient.authoringSystemForeignKey
                        },
                        medication: null,
                        name: name,
                        service: {
                            id: emptyGuid,
                            authoringSystem: props.service.authoringSystem,
                            authoringSystemForeignKey: props.service.authoringSystemForeignKey
                        },
                        isFreeTextMedication: true,
                        supplyAllRepeatsAtOnce: false,
                        performedOn: moment().format(ValidDateFormats.IsoFormat),
                        generatedOn: moment().format(ValidDateFormats.NodeDateTimeTimezone),
                        problems: [],
                        viewingRight: props.getDefaultViewingRight(),
                        expiresOn: medicationExpiryType === MedicationExpiryType.Chart
                            ? maxPharmacyRequestExpiry.format(ValidDateFormats.IsoFormat)
                            : null,
                        notes: '',
                        medicationType: medicationType,
                        medicationExpiry: medicationExpiryType,
                        pharmacyRequestId: null,
                        jurisdictionalControlledSubstanceReference: null
                    };
                    return [4 /*yield*/, createNewMedication(request, PoisonScheduleStatus.None)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleMedicationUpdated = function () {
        medicationsSummaryAsync.getApi(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, convertFilterToQueryObject(filterState.state, props.encounter.authoringSystem, props.encounter.authoringSystemForeignKey, props.service.authoringSystem, props.service.authoringSystemForeignKey, sorting.sortingColumn, sorting.sortingOrder));
        medicationTimeLineState.reloadAllOpenTimeLine(convertTimelineFilterToQueryObject(filterState.state, props.encounter.authoringSystem, props.encounter.authoringSystemForeignKey));
    };
    var onMedicationDeleted = function (medicationId) {
        handleMedicationUpdated();
        updateLocalEventId();
        if (selectedMedicationIdFromRoute === medicationId)
            history.push(routeForSummary(rootMatch.url), {
                dialog: Dialog.None,
                eventId: moment().format(ValidDateFormats.DateTimeIso)
            });
    };
    var _2 = __read(useState(loadFromLocalStorage(ApplicationStorageKeys.MedicationsSummaryTableSorting, {
        sortingColumn: MedSummarySortColumn.Product,
        sortingOrder: MedSummarySortOrder.Asc
    })), 2), sorting = _2[0], setSorting = _2[1];
    var updateSorting = function (newSorting) {
        saveToLocalStorage(ApplicationStorageKeys.MedicationsSummaryTableSorting, newSorting);
        setSorting(newSorting);
    };
    useEffect(function () {
        medicationsSummaryAsync.getApi(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, convertFilterToQueryObject(filterState.state, props.encounter.authoringSystem, props.encounter.authoringSystemForeignKey, props.service.authoringSystem, props.service.authoringSystemForeignKey, sorting.sortingColumn, sorting.sortingOrder));
    }, [sorting]);
    var _3 = __read(useState(), 2), productColumnWidth = _3[0], setProductColumnWidth = _3[1];
    var updateProductColumnWidth = function () {
        function reducer(previousValue, currentValue) {
            var _a, _b;
            if (currentValue.columnName !== 'product') {
                return previousValue + parseInt((_b = (_a = currentValue.width) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '0');
            }
            return 0;
        }
        var fixedColumnsWidth = columnExtensions.reduce(reducer, 0);
        var scrollbar = 18;
        var expander = 48;
        var screenWidth = window.innerWidth;
        var newWidth = screenWidth - fixedColumnsWidth - scrollbar - expander;
        var minWidth = 300;
        var width = Math.max(newWidth, minWidth);
        if (productColumnWidth !== width) {
            setProductColumnWidth(width);
        }
    };
    var productColumnWidthPicker = useCallback(debounce(function () {
        updateProductColumnWidth();
    }, 300), []);
    useEffect(function () {
        updateProductColumnWidth();
        window.addEventListener('resize', productColumnWidthPicker);
        return function () {
            window.removeEventListener('resize', productColumnWidthPicker);
        };
    }, []);
    var columnExtensions = [
        {
            columnName: 'product',
            width: productColumnWidth
        },
        {
            columnName: 'courseInstructions',
            width: 310
        },
        {
            columnName: 'courseScriptNumber',
            align: 'right',
            width: 190
        },
        {
            columnName: 'courseAddedOn',
            align: 'right',
            width: 130
        },
        {
            columnName: 'courseExpires',
            align: 'right',
            width: 130
        },
        {
            columnName: 'courseDuration',
            width: 145
        },
        {
            columnName: 'startedOn',
            align: 'right',
            width: 130
        },
        {
            columnName: 'totalDuration',
            width: 145
        },
        {
            columnName: 'allowedActions',
            width: 150
        }
    ];
    var columnSorting = [
        {
            columnName: 'product',
            sortingEnabled: true
        },
        {
            columnName: 'courseInstructions',
            sortingEnabled: false
        },
        {
            columnName: 'courseScriptNumber',
            sortingEnabled: false
        },
        {
            columnName: 'courseAddedOn',
            sortingEnabled: true
        },
        {
            columnName: 'courseExpires',
            sortingEnabled: false
        },
        {
            columnName: 'courseDuration',
            sortingEnabled: false
        },
        {
            columnName: 'startedOn',
            sortingEnabled: false
        },
        {
            columnName: 'totalDuration',
            sortingEnabled: false
        },
        {
            columnName: 'allowedActions',
            sortingEnabled: false
        }
    ];
    var CustomCellMemo = function (cellProps) {
        return (React.createElement(StyledTableCell, __assign({}, cellProps, { onClick: function (item) { return navigateToMedication(item.lastMedication.id); } })));
    };
    function openFinaliseMedicationDialog() {
        showDialog(Dialog.Finalise);
    }
    var onReprescribe = function (medicationId, patientMedications) {
        setSelectedMedicationIdFromList('');
        updateMedicationLoaded();
        handleMedicationUpdated();
        if (medicationId) {
            navigateToMedication(medicationId, true);
        }
        else {
            setShowClinicalDecisionSupportDialog(isCdsEnabled ? true : false);
        }
        setSelectedMedicationIdFromList(medicationId);
    };
    var filterState = useMedicationsSummaryFilter(function (filter) {
        return medicationsSummaryAsync.getApi(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, convertFilterToQueryObject(filter, props.encounter.authoringSystem, props.encounter.authoringSystemForeignKey, props.service.authoringSystem, props.service.authoringSystemForeignKey, sorting.sortingColumn, sorting.sortingOrder));
    }, props.userId);
    useEffect(function () {
        medicationTimeLineState.reloadAllOpenTimeLine(convertTimelineFilterToQueryObject(filterState.state, props.encounter.authoringSystem, props.encounter.authoringSystemForeignKey));
    }, [filterState.state]);
    var _4 = __read(useState(null), 2), represcribeMedication = _4[0], setReprescribeMedications = _4[1];
    var handleSaveMedicationsToReprescribe = function (medicationsToReprescribe) { return __awaiter(void 0, void 0, void 0, function () {
        var shortenedMedsDetails, searchParam;
        return __generator(this, function (_a) {
            shortenedMedsDetails = medicationsToReprescribe.medications[0].shortenedMedsDetails;
            if (shortenedMedsDetails === null || shortenedMedsDetails === void 0 ? void 0 : shortenedMedsDetails.productRemoved) {
                setShortenedMedToReprescribe(medicationsToReprescribe);
                searchParam = shortenedMedsDetails.isOnLemiOrLmbc && shortenedMedsDetails.brandName
                    ? shortenedMedsDetails.brandName
                    : shortenedMedsDetails.activeIngredientName;
                setMedicationBrowserNameFilter(searchParam);
                showMedicationsBrowser(shortenedMedsDetails.type);
                return [2 /*return*/, {
                        medications: []
                    }];
            }
            // Normal represcribe flow
            if (controlledMedicationHandler.requiresAuthentication(medicationsToReprescribe.medications.map(function (it) { var _a; return (_a = it.poisonSchedule) === null || _a === void 0 ? void 0 : _a.poisonScheduleStatus; }))) {
                controlledMedicationHandler.showControlledMedicationDialog({
                    action: {
                        type: ControlledDialogActions.Represcribe,
                        payload: medicationsToReprescribe,
                        patient: props.patient
                    },
                    handleCancel: function () {
                        // Should take no further action.
                    }
                });
                // Return empty array since no medication have been represcribed yet.
                return [2 /*return*/, {
                        medications: []
                    }];
            }
            else {
                return [2 /*return*/, represcribeMedications(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, medicationsToReprescribe)];
            }
            return [2 /*return*/];
        });
    }); };
    var saveFreeTextMedication = function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var expiresOnMoment, performedOnMoment, durationType, represcribe;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            expiresOnMoment = expiryDate(config.patientMedication.expiresOn);
            performedOnMoment = performedDate(config.patientMedication.performedOn, ValidDateFormats.IsoFormat);
            durationType = getDurationType(expiresOnMoment, performedOnMoment);
            represcribe = {
                medications: [
                    {
                        medication: __assign(__assign({}, config.patientMedication), { name: (_a = config.medication) === null || _a === void 0 ? void 0 : _a.name }),
                        expiryType: config.patientMedication.expiryType,
                        expiresOn: getExpiresOn(true, performedDate(moment().endOf('day').format(ValidDateFormats.IsoFormat), ValidDateFormats.IsoFormat), expiresOnMoment, performedOnMoment, durationType),
                        poisonSchedule: isFreeTextMedication(config.medication)
                            ? EmptyPoisonSchedule
                            : (_b = config.medication) === null || _b === void 0 ? void 0 : _b.poisonSchedule,
                        overrideMedicationType: config.type,
                        overrideProductPack: config.medication,
                        overridePbsDetail: isFreeTextMedication(config.medication)
                            ? undefined
                            : (_c = config.medication.pbsDetail) !== null && _c !== void 0 ? _c : undefined
                    }
                ],
                represcribedOn: moment().format(ValidDateFormats.NodeDateTimeTimezone),
                service: {
                    id: emptyGuid,
                    authoringSystem: props.service.authoringSystem,
                    authoringSystemForeignKey: props.service.authoringSystemForeignKey
                }
            };
            return [2 /*return*/, handleSaveMedicationsToReprescribe(represcribe)];
        });
    }); };
    var handleFreeTextMedicationSelection = function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var ids, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, saveFreeTextMedication(config)];
                case 1:
                    ids = _a.sent();
                    setReprescribeMedications(null);
                    if (ids.medications.length) {
                        onReprescribe(ids.medications[0]);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_6 = _a.sent();
                    displayError('Unable to represcribe');
                    setReprescribeMedications(null);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    if (medicationsSummaryAsync.data === null || medicationsSummaryAsync.loadCount === 0) {
        return (React.createElement(LayoutCentral, null,
            React.createElement(LoadingPlaceholder, null)));
    }
    else {
        var summariesGroupedByCourse = groupBy(medicationsSummaryAsync.data, function (it) { return it.lastMedication.course; });
        var sortedArrayOfGroups = Object.entries(summariesGroupedByCourse)
            .slice()
            .sort(function (a, b) {
            return coursesSortOrder.indexOf(a[0]) -
                coursesSortOrder.indexOf(b[0]);
        });
        var medicationsSummary_1 = sortedArrayOfGroups.flatMap(function (_a) {
            var _b = __read(_a, 2), _ = _b[0], values = _b[1];
            return values;
        });
        var getSummaryTable_1 = function () {
            return medicationsSummary_1.length === 0 ? (React.createElement(MedicationPlaceholder, { onClick: function (event) { return setAddNewMenuTarget(event.currentTarget); } })) : (React.createElement("div", { className: styles.summaryWrapper },
                React.createElement("div", { className: styles.autoVerticalScroll },
                    React.createElement(MedicationSummaryDataTable, { loading: medicationsSummaryAsync.status === UseAsyncStatus.Reloading, sorting: [
                            {
                                columnName: sorting.sortingColumn === MedSummarySortColumn.Product
                                    ? 'product'
                                    : 'courseAddedOn',
                                direction: sorting.sortingOrder === MedSummarySortOrder.Asc ? 'asc' : 'desc'
                            }
                        ], sortingControl: columnSorting, onSortingChange: function (columnSorting) {
                            var sortInformation = columnSorting[0];
                            if (sortInformation) {
                                updateSorting({
                                    sortingOrder: sortInformation.direction === 'asc'
                                        ? MedSummarySortOrder.Asc
                                        : MedSummarySortOrder.Desc,
                                    sortingColumn: sortInformation.columnName === 'product'
                                        ? MedSummarySortColumn.Product
                                        : sortInformation.columnName === 'courseAddedOn'
                                            ? MedSummarySortColumn.CourseAdded
                                            : MedSummarySortColumn.Product
                                });
                            }
                            else {
                                updateSorting({
                                    sortingColumn: MedSummarySortColumn.Product,
                                    sortingOrder: MedSummarySortOrder.Asc
                                });
                            }
                        }, scrollMode: props.scrollMode, columns: getColumns({
                            editMedication: function (medicationId) {
                                setShowPatientMedicationPatchView(medicationId);
                            },
                            adjustMedication: function (medicationId) {
                                navigateToMedication(medicationId);
                            },
                            stopMedication: function (medicationId) {
                                setSelectedMedicationIdFromList(medicationId);
                                showDialog(Dialog.Stop);
                            },
                            deleteMedication: function (medicationName, medicationId) {
                                setSelectedMedicationNameFromList(medicationName);
                                setSelectedMedicationIdFromList(medicationId);
                                setIgnoreSelectedIdFromRoute(true);
                                setShowDeleteMedication(true);
                            },
                            represcribeMedication: function (medicationName, medication, productPack, isFreeTextMedication) {
                                setSelectedMedicationNameFromList(medicationName);
                                setSelectedLastMedicationFromList({
                                    medication: medication,
                                    productPack: productPack
                                });
                                setIgnoreSelectedIdFromRoute(true);
                                medication.type === MedicationType.MedicationHistory && isFreeTextMedication
                                    ? setReprescribeMedications({
                                        patientMedication: medication,
                                        text: medicationName !== null && medicationName !== void 0 ? medicationName : ''
                                    })
                                    : setShowReprescribeSingleMedicationDialog(true);
                            },
                            reviewVerbalOrder: function (medication) {
                                setSelectedMedicationIdFromList(medication.id);
                                setShowReviewVerbalOrder(true);
                            },
                            reassignVerbalOrder: function (medication) {
                                setSelectedMedicationIdFromList(medication.id);
                                setShowReassignVerbalOrder(true);
                            },
                            verbalOrderTerm: medicationSettings.settings.verbalOrderTerm
                        }), data: medicationsSummary_1, cellComponent: CustomCellMemo, customCheckbox: function (data, selected, onToggle) {
                            var _a;
                            return (React.createElement(Checkbox, { checked: selected, onClick: function () { return onToggle(); }, color: 'default', className: classNames(styles.checkboxBase, (_a = {},
                                    _a[styles.selectedCheckbox] = selected,
                                    _a)) }));
                        }, columnExtensions: columnExtensions, getRowId: function (item) {
                            if (isMedicationsSummary(item))
                                return item.lastMedication.id;
                            return item.key;
                        } }))));
        };
        var displayNavigationPrompt = !!discardAction && !subFormSaved;
        var getContents = function () {
            return (React.createElement("div", { className: styles.detailsPaneWrapper },
                React.createElement(DetailsPane, { state: showPatientMedicationPatchView ? DetailsPaneState.ChildView : DetailsPaneState.ParentView, noParentBackground: true, onStateChange: function () {
                        setShowPatientMedicationPatchView('');
                    }, onFinaliseMedication: openFinaliseMedicationDialog, getParent: getSummaryTable_1, getParentSummary: function () { return (React.createElement(MedicationsSummaryList, { serviceAuthoringSystem: props.service.authoringSystem, serviceAuthoringSystemForeignKey: props.service.authoringSystemForeignKey, encounterAuthoringSystem: props.encounter.authoringSystem, encounterAuthoringSystemForeignKey: props.encounter.authoringSystemForeignKey, patient: props.patient, filterState: filterState.state, data: medicationsSummary_1, selectedId: selectedMedicationIdFromRoute, onClick: navigateToMedication, stopMedication: function (medId) {
                            setSelectedMedicationIdFromList(medId);
                            showDialog(Dialog.Stop);
                        }, onMedicationDeleted: onMedicationDeleted, deleteMedication: deletePatientMedication, saveMedicationsToReprescribe: handleSaveMedicationsToReprescribe, saveFreeTextMedicationToReprescribe: saveFreeTextMedication, canReprescribe: confirmFormIsValidAndTakeAction, onReprescribe: onReprescribe, medicationTimeLineState: medicationTimeLineState, controlledMedicationHandler: controlledMedicationHandler })); }, getChild: function () {
                        return showPatientMedicationPatchView && eventId ? (React.createElement(MedicationOverviewLoader, { key: selectedMedicationIdFromRoute + "-" + eventId + "-" + localEventId, patientMedicationId: showPatientMedicationPatchView, patient: props.patient, encounter: props.encounter, service: props.service, getDefaultViewingRight: props.getDefaultViewingRight, onFormSaved: function () {
                                setSubFormSaved(true);
                            }, onFormUnsaved: function () {
                                setSubFormSaved(false);
                            }, onUpdate: handleMedicationUpdated, onUnmount: function () {
                                setDiscardAction(null);
                                setSubFormSaved(true);
                            }, controlledMedicationHandler: controlledMedicationHandler })) : (React.createElement(MedicationPlaceholder, { onClick: function (event) {
                                return setAddNewMenuTarget(event.currentTarget);
                            } }));
                    } })));
        };
        var getLeftPanel = function () {
            return (React.createElement("div", { className: styles.leftContainer },
                React.createElement("div", { className: styles.filterHeader },
                    React.createElement("div", { className: styles.title }, "Filter"),
                    React.createElement(Tooltip, { title: 'Close', placement: 'bottom' },
                        React.createElement("span", { className: styles.iconButton },
                            React.createElement(Button, { testId: 'button-close', onClick: function () { return setFilterOpen(!filterOpen); }, mode: ButtonMode.text, iconOnly: true, noShadowOnHover: true, subtleShadeOnHover: true },
                                React.createElement(CloseIcon, { color: iconLight }))))),
                React.createElement(MedicationsSummaryFilter, __assign({}, filterState))));
        };
        var pharmacyRequestAnimationStyle = showPharmacyRequestWizard === PharmacyRequestWizardView.AsStandAloneWizard
            ? ModalAnimationStyle.OpenAndClose
            : ModalAnimationStyle.None;
        return (React.createElement(React.Fragment, null,
            React.createElement(TwoPanelLayout, { leftPanelOpen: filterOpen, noPadding: true, contentsLeft: true, mask: true, leftPanel: getLeftPanel(), contents: getContents(), header: React.createElement(MedicationSummaryHeader, { service: props.service, filterOpen: filterOpen, numberOfDraftMedications: draftMedications.length, onFilterOpen: setFilterOpen, getProviderRoute: props.getProviderRoute, goToEncounterFinaliseRoute: props.goToEncounterFinaliseRoute, onReview: function () {
                        setShowPharmacyRequestWizard(PharmacyRequestWizardView.AsStandAloneWizard);
                    }, onFinaliseMedication: openFinaliseMedicationDialog, stopMedication: function () {
                        showDialog(Dialog.Stop);
                    }, represcribeMedication: function () {
                        setIgnoreSelectedIdFromRoute(true);
                        setShowReprescribeMedication(true);
                        setIsMultiReprescribe(true);
                        saveToLocalStorage(ApplicationStorageKeys.MedicationsSummaryS8MultiReprescribe, {
                            isMultiReprescribe: true
                        });
                    }, showMedicationsBrowser: showMedicationsBrowser }) }),
            React.createElement(NavigationPrompt, { open: displayNavigationPrompt, onCancel: function () {
                    setDiscardAction(null);
                }, onDiscard: function () {
                    triggerDiscardAction();
                } }),
            React.createElement(AddMedicationMenu, { anchor: addNewMenuTarget, onClose: function () { return setAddNewMenuTarget(null); }, canAddMedication: confirmFormIsValidAndTakeAction, showMedicationsBrowser: showMedicationsBrowser }),
            React.createElement(ControlledMedicationDialog, { handler: controlledMedicationHandler }),
            !!showMedicationsBrowserDialog && (React.createElement(MedicationsBrowserDialog, { allowFreeTextMedication: showMedicationsBrowserDialog === MedicationType.MedicationHistory, isComplementaryTherapy: showMedicationsBrowserDialog === MedicationType.ComplementaryTherapyOrder, onCancel: closeMedicationsBrowser, onSelectMedication: selectMedicationFromBrowser, onSelectFreeTextMedication: function (name) {
                    return selectFreeTextMedicationFromBrowser(name, showMedicationsBrowserDialog);
                }, defaultFilter: {
                    productName: medicationBrowserNameFilter
                } })),
            (showPharmacyRequestWizard === PharmacyRequestWizardView.AsWizardStep ||
                showPharmacyRequestWizard === PharmacyRequestWizardView.AsStandAloneWizard) && (React.createElement(AddPharmacyRequestForm, { animationStyle: pharmacyRequestAnimationStyle, headlessUpdate: {
                    onSuccess: function (response) {
                        var _a;
                        setShowPharmacyRequestWizard(PharmacyRequestWizardView.None);
                        if ((_a = props.headlessPharmacyRequest) === null || _a === void 0 ? void 0 : _a.onSuccess) {
                            props.headlessPharmacyRequest.onSuccess(response);
                        }
                        else {
                            displayMessage(response.message);
                        }
                        handleMedicationUpdated();
                    },
                    onFailure: function (response) {
                        var _a;
                        setShowPharmacyRequestWizard(PharmacyRequestWizardView.None);
                        if ((_a = props.headlessPharmacyRequest) === null || _a === void 0 ? void 0 : _a.onFailure) {
                            props.headlessPharmacyRequest.onFailure(response);
                        }
                        else {
                            displayError(response.message);
                        }
                        handleMedicationUpdated();
                    }
                }, onCreatePharmacyRequest: getOnCreatePharmacyRequest({
                    patient: props.patient,
                    service: props.service
                }), getMedicationsToRequest: function () {
                    return getMedicationsToRequestByPatientAuthKeys(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, { service: props.service });
                }, goToMedications: function () {
                    setShowPharmacyRequestWizard(PharmacyRequestWizardView.None);
                    handleMedicationUpdated();
                }, onClose: function () {
                    setShowPharmacyRequestWizard(PharmacyRequestWizardView.None);
                }, onSuccess: function () {
                    setShowPharmacyRequestWizard(PharmacyRequestWizardView.None);
                    handleMedicationUpdated();
                } })),
            showFinaliseMedicationWizard && (React.createElement(FinaliseMedicationForm, { serviceAuthoringSystem: props.service.authoringSystem, serviceAuthoringSystemForeignKey: props.service.authoringSystemForeignKey, encounter: props.encounter, patient: props.patient, showPatientDialog: props.showPatientDialog, onMedicationDeleted: function (medId) {
                    if (medId === selectedMedicationIdFromRoute) {
                        history.push(routeForSummary(rootMatch.url));
                    }
                    handleMedicationUpdated();
                }, onGotoCreatePharmacyRequest: function () {
                    showDialog(Dialog.None);
                    setShowPharmacyRequestWizard(PharmacyRequestWizardView.AsWizardStep);
                }, onView: function (medId) {
                    showDialog(Dialog.None);
                    navigateToMedication(medId);
                }, onFinaliseMedications: function (meds) {
                    return finaliseMedications(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, meds);
                }, deleteMedication: deletePatientMedication, getMedicationsToFinalise: function () {
                    return getPatientMedicationToFinalise(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, {
                        encounter: {
                            id: emptyGuid,
                            authoringSystem: props.encounter.authoringSystem,
                            authoringSystemForeignKey: props.encounter.authoringSystemForeignKey
                        }
                    });
                }, onClose: function (medicationsHaveChanged) {
                    showDialog(Dialog.None);
                    if (medicationsHaveChanged) {
                        updateMedicationLoaded();
                        handleMedicationUpdated();
                    }
                }, onSuccess: function () {
                    showDialog(Dialog.None);
                    updateMedicationLoaded();
                    handleMedicationUpdated();
                } })),
            showStopMedication && (React.createElement(StopMedication, { selectedId: selectedMedicationIdFromList ? selectedMedicationIdFromList : undefined, getMedicationToStop: function (config) {
                    return getMedicationsToStopByAuth(config, props.patient.authoringSystem, props.patient.authoringSystemForeignKey);
                }, saveMedicationsToStop: function (medicationsToStop) {
                    return stopMedications(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, medicationsToStop);
                }, onCancel: function () {
                    showDialog(Dialog.None);
                    setSelectedMedicationIdFromList('');
                }, onComplete: function () {
                    showDialog(Dialog.None);
                    setSelectedMedicationIdFromList('');
                    updateMedicationLoaded();
                    handleMedicationUpdated();
                } })),
            showDeleteMedication && (React.createElement(DeleteMedicationDialog, { medicationName: selectedMedicationNameFromList, medicationId: selectedMedicationIdFromList, onDelete: function () {
                    setSelectedMedicationIdFromList('');
                    setSelectedMedicationNameFromList('');
                    updateMedicationLoaded();
                    onMedicationDeleted(selectedMedicationIdFromList);
                }, setShowDeleteMedicationDialog: function (show) {
                    setShowDeleteMedication(show);
                    setSelectedMedicationIdFromList('');
                } })),
            showReviewVerbalOrder && (React.createElement(ReviewVerbalOrderDialog, { medicationId: selectedMedicationIdFromList, patient: props.patient, onSave: function () {
                    showDialog(Dialog.None);
                    setSelectedMedicationIdFromList('');
                    handleMedicationUpdated();
                }, setShowReviewVerbalOrderDialog: function (show) {
                    setShowReviewVerbalOrder(show);
                    setSelectedMedicationIdFromList('');
                } })),
            showReprescribeSingleMedicationDialog && selectedLastMedicationFromList && (React.createElement(ReprescribeSingleMedicationDialog, { serviceAuthoringSystem: props.service.authoringSystem, serviceAuthoringSystemForeignKey: props.service.authoringSystemForeignKey, medicationName: selectedMedicationNameFromList, lastMedication: selectedLastMedicationFromList, patient: props.patient, saveMedicationsToReprescribe: handleSaveMedicationsToReprescribe, onClose: function () { return setShowReprescribeSingleMedicationDialog(false); }, controlledMedicationHandler: controlledMedicationHandler, onReprescribe: onReprescribe })),
            represcribeMedication && (React.createElement(ReprescribeFreeTextMedication, { patientMedication: represcribeMedication.patientMedication, freeText: represcribeMedication.text, onSelectionMedication: handleFreeTextMedicationSelection, onClose: function () { return setReprescribeMedications(null); } })),
            showReprescribeMedication && (React.createElement(ReprescribeMedication, { serviceAuthoringSystem: props.service.authoringSystem, serviceAuthoringSystemForeignKey: props.service.authoringSystemForeignKey, patient: props.patient, selectedId: ignoreSelectedIdFromRoute
                    ? selectedMedicationIdFromList
                        ? selectedMedicationIdFromList
                        : undefined
                    : selectedMedicationIdFromRoute, getMedicationToReprescribe: function (config) {
                    return getMedicationsToReprescribeByAuth(config, props.patient.authoringSystem, props.patient.authoringSystemForeignKey);
                }, saveMedicationsToReprescribe: function (medicationsToReprescribe) {
                    return represcribeMedications(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, medicationsToReprescribe);
                }, onCancel: function () {
                    setShowReprescribeMedication(false);
                    setSelectedMedicationIdFromList('');
                }, onComplete: function (medicationId, patientMedications) {
                    setShowReprescribeMedication(false);
                    onReprescribe(medicationId, patientMedications);
                }, controlledMedicationHandler: controlledMedicationHandler })),
            showReassignVerbalOrder && (React.createElement(ReassignVerbalOrderDialog, { medicationId: selectedMedicationIdFromList, onClose: function (refreshNeeded) {
                    setShowReassignVerbalOrder(false);
                    if (refreshNeeded)
                        handleMedicationUpdated();
                } })),
            selectedMedicationIdFromRoute && (React.createElement(EditMedicationLoader, { patientMedicationId: selectedMedicationIdFromRoute, patient: props.patient, encounter: props.encounter, service: props.service, controlledMedicationHandler: controlledMedicationHandler, getDefaultViewingRight: props.getDefaultViewingRight, onCancel: function () { return history.push(routeForSummary(rootMatch.url)); }, onUpdate: function () {
                    handleMedicationUpdated();
                    history.push(routeForSummary(rootMatch.url));
                } })),
            showClinicalDecisionSupportDialog && (React.createElement(ClinicalDecisionSupportDialog, { onDelete: function () {
                    setShowDeleteMedication(false);
                    handleMedicationUpdated();
                }, handleErrorOnDelete: function (err) {
                    throwError(err);
                    handleMedicationUpdated();
                    history.push(routeForSummary(rootMatch.url));
                }, setShowClinicalDecisionSupportDialog: function (show) {
                    setShowClinicalDecisionSupportDialog(show);
                    setIsMultiReprescribe(false);
                    deleteFromLocalStorage(ApplicationStorageKeys.MedicationsSummaryS8MultiReprescribe);
                }, setShowDeleteMedication: function (show) {
                    setShowDeleteMedication(show);
                }, setDeleteMedicationId: function (id) {
                    setSelectedMedicationIdFromList(id);
                }, setDeleteMedicationName: function (name) {
                    setSelectedMedicationNameFromList(name);
                }, onUpdate: function () {
                    handleMedicationUpdated();
                    history.push(routeForSummary(rootMatch.url));
                }, isReprescribe: true, setIgnoreFormValidation: function (val) {
                    true;
                }, patient: props.patient, encounter: props.encounter, medication: undefined, setCdsResponse: function (response) {
                } }))));
    }
};
